
























    import {Component, Prop} from "vue-property-decorator"
    import AbpBase from "../../../../lib/abpbase"
    import {QueryMaterialSyn} from "@/api/material"

    @Component({
        components: {}
    })
    export default class Syn extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean
        @Prop({type: Array, default: []}) data: any
        tenantId = ''
        tenantList:any = []
        async getSelect(){
            this.tenantList = (await this.QueryTenant({queryString:'',pageSize:10000,page:1}) as any).data
        }
        created() {
            this.getSelect()   
        }
        async save(){
            if (this.tenantId) {
                let res = await QueryMaterialSyn({ids:this.data, tenantId:this.tenantId})
				if (res.code === 2000) {
				    this.cancel()
				}
            } else {
                this.$message.error("选择中心")
            }
        }
        cancel() {
            this.$emit('input', false);
        }
    }
